export const ratingsSlidingIcons = [
  { id: 'accessible_squares', label: 'accessible_squares' },
  { id: 'apples', label: 'apples' },
  { id: 'blue_round', label: 'blue_round' },
  { id: 'blush_emoji', label: 'blush_emoji' },
  { id: 'btc', label: 'btc' },
  { id: 'canada', label: 'canada' },
  { id: 'computer', label: 'computer' },
  { id: 'crown', label: 'crown' },
  { id: 'desk', label: 'desk' },
  { id: 'double_phones', label: 'phones' },
  { id: 'eyes_closed_happy_emoji', label: 'eyes_closed_happy_emoji' },
  { id: 'flags', label: 'flag' },
  { id: 'hands_up', label: 'hands_up' },
  { id: 'headphones_happy_face_emoji', label: 'headphones_happy_face_emoji' },
  { id: 'hearts', label: 'hearts' },
  { id: 'lemur', label: 'lemur' },
  { id: 'music_note', label: 'music_note' },
  { id: 'office_chair', label: 'office_chair' },
  { id: 'otter', label: 'otter' },
  { id: 'panda', label: 'panda' },
  { id: 'pencil', label: 'pencil' },
  { id: 'penguin', label: 'penguin' },
  { id: 'phone_in_hand', label: 'phone_in_hand' },
  { id: 'pizza', label: 'pizza' },
  { id: 'puppy', label: 'puppy' },
  { id: 'single_phone', label: 'single_phone' },
  { id: 'speech_bubbles', label: 'speech_bubbles' },
  { id: 'stars', label: 'stars' },
  { id: 'teal_square', label: 'teal_square' },
  { id: 'thumbs_up', label: 'thumbs_up' },
  { id: 'wifi', label: 'wifi' },
];
